import { getCountryNameByCountryCode, getStatusDescriptionFromStatusValue, getRegionNameFromRegionCode, getQuoteTypeText } from '../../../../../utils/utility';
import { getDateWithSpecificFormat } from '../../../../data-transform';

export default function vendorCTInitialQuotesTableColumns(config) {
    const { quoteList = [], refusedReasonList = [], vendorName = "" } = config.data;
    let result = {};
    let tableData = [];
    let prefillingData = {};

    const getRefusedReasonList = () => {
        let refusedReasons = [
            { id: "NO_VALUE", label: "Select reason" },
            ...refusedReasonList.map(reason => ({
                id: reason, label: getStatusDescriptionFromStatusValue(reason)
            }))
        ]
        return refusedReasons;
    };

    quoteList.forEach((quote, index) => {
        let row = [];
        const rowId = quote.quoteId;
        const winningDeliveryPartners = Array.isArray(quote.winningDeliveryPartner)
            ? quote.winningDeliveryPartner.filter(option => option)
            : (quote.winningDeliveryPartner ? [quote.winningDeliveryPartner] : []);
        const isWinningVendor = winningDeliveryPartners.includes(vendorName);
        config.columns.forEach(column => {
            let columnValue = "";
            let isDisabled = false;
            let linkDestination = "";
            let customEventHandler = null;
            let isOverflowingContent = false;
            let columnValueData = null;
            let clickHandler = null;
            let isPopoverInfo = false;


            let displayAsIs = column.data.displayInBodyAsIs;
            if (column.data.displayInBodyAs == "string") {
                if (column.id === "quoteNumber" && quote.quoteId) {
                    displayAsIs = true;
                    columnValue = quote.quoteId;
                }
                else if (column.id === "quoteType") {
                    columnValue = getQuoteTypeText(quote.quoteType);
                }
                else if (column.id === "dateOfRequest") {
                    columnValue = getDateWithSpecificFormat(quote.createdDate) || "";
                    displayAsIs = true;
                }
                else if (column.id === "CTResponsible") {
                    columnValue = quote.ctResponsible || "";
                    displayAsIs = true;
                }
                else if (column.id === "countriesRequested") {
                    columnValue = quote.countryList && quote.countryList.length ? quote.countryList.join() : "";
                    displayAsIs = true;
                    isOverflowingContent = true;
                }
                else if (column.id === "geographicalScope") {
                    columnValue = quote.geographicalScope || "";
                    displayAsIs = true;
                }
                else if (column.id === "QuotationSubmissionDateByVendor") {
                    columnValue = getDateWithSpecificFormat(quote.quotationSubmissionDate) || "-";
                    displayAsIs = true;
                }
                else if (column.id === "customerName") {
                    columnValue = quote.customerName || "";
                    displayAsIs = true;
                }
                else if (column.id === "status") {
                    columnValue = getStatusDescriptionFromStatusValue(quote.status) || "";
                    isPopoverInfo = true;
                    displayAsIs = true;
                }
                else if (column.id === "region") {
                    columnValue = getRegionNameFromRegionCode(quote.region) || "";
                    displayAsIs = true;
                }
                else if (column.id === "revitalizeCountries") {
                    isDisabled = true;
                    if (quote.quoteType === 'DRS_REVITALIZE') {
                        columnValue = quote.revitalizeCountries || "";
                        isDisabled = false
                    }
                }
                else if (column.id === "numberOfRevitalizeAssets") {
                    isDisabled = true;
                    if (quote.quoteType === 'DRS_REVITALIZE') {
                        columnValue = quote.numberOfRevitalizeAssets || "";
                        isDisabled = false
                    }
                }
                else if (column.id === "hpFileUploadStatus") {
                    isDisabled = true;
                    if (quote.quoteType === 'DRS_REVITALIZE') {
                        columnValue = getStatusDescriptionFromStatusValue(quote.hpFileUploadStatus) || "";
                        isDisabled = false
                    }
                }
                else if (column.id === "vendorQuoteStatus") {
                    columnValue = (quote.status === "ACCEPTED" || quote.status === "LOST")
                        ? getStatusDescriptionFromStatusValue(isWinningVendor ? "ACCEPTED" : "LOST")
                        : (quote.status === "VENDOR_PRICES_PENDING" || quote.status === "PARTIALLY_CREATED")
                            ? getStatusDescriptionFromStatusValue(quote.quotationSubmissionDate ? "VENDOR_PRICES_PROVIDED" : "VENDOR_PRICES_PENDING")
                        : getStatusDescriptionFromStatusValue(quote.status) || "";
                }
                else if (column.id === "countriesAssignedToVendor") {
                    columnValue = (quote.status === "ACCEPTED" && isWinningVendor && quote.winingCountryVendor && quote.winingCountryVendor[vendorName])
                        ? quote.winingCountryVendor[vendorName]
                        : "-";
                    displayAsIs = true;
                }
            }
            else if (column.data.displayInBodyAs == "downloadIcon" && column.id == "downloadQuoteRequest") {
                displayAsIs = true;
                if (quote.rateCardOption !== "vendor_specific") {
                    isDisabled = true;
                }
                columnValue = { labelId: "download_Vendor_CT_Initial_Quotes", disabled: isDisabled } || "";
                customEventHandler = config.bodyButtonsHandler.handleCTInitialQuoteDownload ? event => config.bodyButtonsHandler.handleCTInitialQuoteDownload(event, rowId, index) : null;
            }
            else if (column.data.displayInBodyAs == "uploadIcon" && column.id == "uploadPrices") {
                displayAsIs = true;
                if ((quote.rateCardOption !== "vendor_specific" && quote.status !== "VENDOR_PRICES_PENDING" && !quote.quotationSubmissionDate)
                    || (quote.status === "VENDOR_PRICES_PENDING" && quote.quotationSubmissionDate) // Fix for SUPP2-6074
                    || (quote.status == "VENDOR_PRICES_PROVIDED") || (quote.status == "CREATED")
                    || (quote.status == "LOST")
                    || (quote.status == "ACCEPTED")
                    || (quote.status == "REJECTED")
                    || (quote.status == "ON_HOLD")
                    || (quote.status == "EXPIRED")
                    || (quote.status == "VENDOR_PRICES_REFUSED")
                    || (quote.refusedStatus == "VENDOR_PRICES_PROVIDED")) {
                    isDisabled = true;
                }
                columnValue = { labelId: "upload_Vendor_CT_Initial_Quotes", disabled: isDisabled } || "";
                customEventHandler = config.bodyButtonsHandler.handleCTInitialQuoteUpload ? event => config.bodyButtonsHandler.handleCTInitialQuoteUpload(event, rowId) : null;
            }
            else if (column.data.displayInBodyAs === "select") {
                if (column.id === "refusedReason") {
                    columnValue = quote.refusedReason || ""
                    columnValueData = { ...column.data, options: getRefusedReasonList() || [] };
                    columnValueData.defaultValue = columnValue;
                    if ((quote.rateCardOption !== "vendor_specific" && quote.status !== "VENDOR_PRICES_PENDING" && !quote.quotationSubmissionDate)
                        || (quote.status === "VENDOR_PRICES_PENDING" && quote.quotationSubmissionDate) // Fix for SUPP2-6074
                        || (quote.status == "VENDOR_PRICES_PROVIDED") || (quote.status == "CREATED")
                        || (quote.status == "LOST")
                        || (quote.status == "ACCEPTED")
                        || (quote.status == "REJECTED")
                        || (quote.status == "ON_HOLD")
                        || (quote.status == "EXPIRED")
                        || (quote.status == "VENDOR_PRICES_REFUSED")
                        || (quote.status == "VENDORS_UNWILLING_TO_BID")) {
                        isDisabled = true;
                    }
                    customEventHandler = config.bodyButtonsHandler.handleRefuseReasonSelection ? event => config.bodyButtonsHandler.handleRefuseReasonSelection(event, quote) : null;
                }
            }

            row.push({
                [column.id]: {
                    columnId: column.id,
                    id: column.id + "|" + rowId,
                    type: column.data.displayInBodyAs,
                    value: columnValueData || columnValue,
                    width: column.width,
                    disabled: (isDisabled || quote.refusedReason) ? true : false,
                    displayAsIs: displayAsIs,
                    isOverflowingContent: isOverflowingContent,
                    linkDestination: linkDestination,
                    prefillingData: prefillingData,
                    showInMobileViewAs: column.showInMobileViewAs,
                    clickHandler: customEventHandler,
                    popoverData: quote?.vendorAdditionalComments && quote.vendorAdditionalComments[vendorName] ? quote.vendorAdditionalComments[vendorName] : "",
                    isPopoverInfo: isPopoverInfo
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    });


    result['columns'] = config.columns;
    result['data'] = tableData;

    return result;
}